import authentication from "./reducers/authentication";
import main from "./reducers/main";
import forms from "./reducers/forms";
import myProfile from "./reducers/myProfile";
import companies from "./reducers/companies";
import numbers from "./reducers/numbers";
import contractors from "./reducers/contractors";
import qrCodes from "./reducers/qrCodes";
import devices from "./reducers/device";
import punches from "./reducers/punches";
import qrCodeClockIn from "./reducers/qrCodeClockIn";
import deviceClockIn from "./reducers/deviceClockIn";
import users from "./reducers/users";

const allReducers = {
  authentication,
  forms,
  myProfile,
  main,
  companies,
  numbers,
  qrCodes,
  punches,
  qrCodeClockIn,
  users,
  contractors,
  devices,
  deviceClockIn,
};

export default allReducers;
